import React, { useCallback, useEffect, useState } from 'react'
import {
    Col,
    DatePicker,
    Form,
    Input,
    Row,
    Tooltip,
    Button,
    Select,
} from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import { useDispatch, useSelector } from 'react-redux'
import { debounce } from 'lodash'
import {
    setFilters,
    setsearch,
    setWorkSpaceId,
} from '../../store/taskLog.slice'
import dayjs from 'dayjs'
import {
    workSpaceListGet,
    workspaceState,
} from '../../../workSpace/workSpace.slice'
import { DOMAIN_LIST, SUPER_ADMIN } from '../../../../constants/roles'
import { loginState } from '../../../login/login.slice'
import { unique } from '../../../../helpers/uniqueArray'

const PanelHeader = () => {
    const dispatch = useDispatch()
    const [form] = Form.useForm()
    const today = dayjs()
    const { Option } = Select
    const { workSpaceDataList, isNext } = useSelector(workspaceState)
    const { userProfile } = useSelector(loginState)
    const [searchInput, setSearchInput] = useState('')
    const [workSpace, setWorkSpace] = useState(null)
    const [filteredWorkSpaceData, setFilteredWorkSpaceData] = useState([])

    const currentDomain = window.location.hostname
    const isDomainAllowed = DOMAIN_LIST.includes(currentDomain)

    // Helper to render company logo + name
    const renderLabel = (data) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
                src={data.logo}
                alt={data.companyName}
                style={{
                    width: 30,
                    height: 30,
                    borderRadius: '50%',
                    marginRight: 8,
                    objectFit: 'cover',
                    boxShadow: "rgba(0, 0, 0, 0.02) 0px 4px 5px 5px"
                }}
            />
            <span>{data.companyName}</span>
        </div>
    )

    useEffect(() => {
        form.setFieldsValue({ datePicker: today })

        dispatch(
            setFilters({
                start: today.startOf('day').toISOString(),
                end: today.endOf('day').toISOString(),
            })
        )
        if (isDomainAllowed) {

            dispatch(
                workSpaceListGet({
                    limit: 10,
                    skip: 0,
                })
            )
        }
    }, [])

    const formatDatePicker = (value) => `${dayjs(value).format('DD MMM YY')}`

    const disabledDate = (current) =>
        current && current > dayjs().startOf('day')


    // Set default value on load
    useEffect(() => {
        if (filteredWorkSpaceData?.length > 0) {
            const defaultWS = filteredWorkSpaceData[0]
            const defaultValue = {
                value: defaultWS._id,
                label: renderLabel(defaultWS),
            }
            setWorkSpace(defaultValue)
            // Optional: dispatch action
            if (defaultValue.value) {
                if (!isDomainAllowed) {
                    dispatch(setWorkSpaceId(defaultValue.value))
                }
            }
        }
    }, [filteredWorkSpaceData])

    useEffect(() => {
        if (userProfile?.role?.roleName === SUPER_ADMIN) {


            if (workSpaceDataList?.length > 0) {
                let array = []
                workSpaceDataList?.length > 0 &&
                    workSpaceDataList.forEach((data) => {
                        if (!DOMAIN_LIST.includes(data?.domain)) {
                            array = [...array, data]
                        }
                    })
                // console.log('array', array)
                let newArray = [...filteredWorkSpaceData, ...array]
                let finalArray = unique(newArray, '_id')
                setFilteredWorkSpaceData(finalArray)
                if (!isNext) {
                    return
                }
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [workSpaceDataList])

    // When user selects a new workspace
    const handleChange = (selected) => {
        const ws = filteredWorkSpaceData.find((item) => item._id === selected.value)
        setWorkSpace({
            value: selected.value,
            label: renderLabel(ws),
        })
        dispatch(setWorkSpaceId(selected.value))
    }

    const debouncedSearch = useCallback(
        debounce((value) => {
            dispatch(setsearch(value))
        }, 500),
        [dispatch]
    )

    useEffect(() => {
        return () => {
            debouncedSearch.cancel() // Cleanup
        }
    }, [debouncedSearch])
    const handleDateChange = (date) => {
        if (!date) return

        dispatch(
            setFilters({
                start: date.startOf('day').toISOString(),
                end: date.endOf('day').toISOString(),
            })
        )
    }

    const handleResetFilter = () => {
        form.setFieldsValue({ datePicker: today }) // Reset to today
        setSearchInput('')
        dispatch(setsearch(''))
        dispatch(
            setFilters({
                start: today.startOf('day').toISOString(),
                end: today.endOf('day').toISOString(),
            })
        )
    }

    return (
        <div>
            <Form form={form}>
                <Row justify="space-between" align="middle" gutter={10}>
                    <Col span={8}>
                        <Input
                            placeholder="Search User"
                            prefix={
                                <SearchOutlined
                                    style={{ fontSize: 16, marginRight: 5 }}
                                />
                            }
                            style={{ height: '44px' }}
                            value={searchInput}
                            onChange={(e) => {
                                debouncedSearch(e.target.value) // Debounce Redux update
                                setSearchInput(e.target.value) // Update local state immediately
                            }}
                        />
                    </Col>
                    <Col span={16}>
                        <div style={{ display: 'flex', justifyContent: 'end' }}>
                            {
                                isDomainAllowed && (
                                    <Select
                                        placeholder="Work space"
                                        style={{
                                            width: '300px',
                                            marginRight: '15px',
                                        }}
                                        labelInValue
                                        value={workSpace}
                                        onChange={handleChange}
                                        optionLabelProp="label"
                                    >
                                        {filteredWorkSpaceData.map((data) => (
                                            <Option
                                                key={data._id}
                                                value={data._id}
                                                label={renderLabel(data)}
                                            >
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                    }}
                                                >
                                                    <img
                                                        src={data.logo}
                                                        alt={data.companyName}
                                                        style={{
                                                            width: 40,
                                                            height: 40,
                                                            borderRadius: '50%',
                                                            marginRight: 10,
                                                            objectFit: 'cover',
                                                            boxShadow: "rgba(0, 0, 0, 0.02) 0px 4px 5px 5px"

                                                        }}
                                                    />
                                                    <div>
                                                        <div
                                                            style={{
                                                                fontWeight: 500,
                                                            }}
                                                        >
                                                            {data.companyName}
                                                        </div>
                                                        <div
                                                            style={{
                                                                fontSize: '12px',
                                                                color: '#888',
                                                            }}
                                                        >
                                                            {data.domain}
                                                        </div>
                                                    </div>
                                                </div>
                                            </Option>
                                        ))}
                                    </Select>
                                )}

                            <Form.Item name="datePicker">
                                <DatePicker
                                    allowClear={false}
                                    format={formatDatePicker}
                                    disabledDate={disabledDate}
                                    style={{ width: '100%' }}
                                    onChange={handleDateChange}
                                />
                            </Form.Item>

                            <Tooltip title="Reset Filter">
                                <Button
                                    type="default"
                                    onClick={handleResetFilter}
                                    style={{ marginLeft: '15px' }}
                                >
                                    Reset Filter
                                </Button>
                            </Tooltip>
                        </div>
                    </Col>
                </Row>
            </Form>
        </div>
    )
}

export default PanelHeader
